
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function scopeProduct1(isTireProduct, isWheelProduct) {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn button button--outline',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '7441'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                function scopeIsTireProductIsWheelProduct2() {
                    var isTireProduct = this.FitmentType?.includes('Tire');
                    var isWheelProduct = this.FitmentType?.includes('Wheel');
                    return _createElement('div', { 'className': 'cm_SearchResult__item' }, _createElement('div', { 'className': 'cm_SearchResult__item-inner' }, _createElement('div', { 'className': 'cm_SearchResult__item-image' }, _createElement('div', { 'className': 'product-card__badge-list' }, this.out_of_stock ? _createElement('span', {
                        'className': 'badge badge--sold-out',
                        'key': '330'
                    }, _translate(`product_out_of_stock`)) : null), _createElement('a', {
                        'href': this.url,
                        'className': 'cm_SearchResult__item-link'
                    }, _createElement('img', {
                        'src': this.imageOrDefault(this.image),
                        'alt': this.removeHTML(this.title),
                        'className': 'cm_SearchResult__item-img',
                        'loading': 'lazy'
                    })), _createElement('div', { 'className': 'cm_SearchResult__item-buttons-container' }, [scopeProduct1.apply(this, [
                            isTireProduct,
                            isWheelProduct
                        ])], !this.out_of_stock && this.wheel_tire_diameter && window.Convermax.isVehicleSelected() && window.location.pathname === '/collections/build-a-package' ? _createElement('button', {
                        'className': 'button button--outline',
                        'onClick': window.Convermax.mountedPackagesAddToCartWithRedirect(this.id, this.variant_ids[0]),
                        'key': '1163'
                    }, '\n          Build a Package\n        ') : null, window.location.href.includes('WheelProductID') ? _createElement('form', {
                        'method': 'post',
                        'action': '/cart/add',
                        'id': 'product-form-' + this.id + '-template--cm_results',
                        'accept-charset': 'UTF-8',
                        'className': 'shopify-product-form',
                        'encType': 'multipart/form-data',
                        'key': '1555'
                    }, _createElement('input', {
                        'type': 'hidden',
                        'name': 'form_type',
                        'value': 'product'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'utf8',
                        'value': '\u2713'
                    }), _createElement('input', {
                        'name': 'quantity',
                        'value': '4',
                        'type': 'hidden'
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids
                    }), _createElement('div', { 'className': 'v-stack gap-4' }, _createElement('buy-buttons', {
                        'form': 'product-form-' + this.id + '-template--cm_results',
                        'class': 'buy-buttons'
                    }, _createElement('button', {
                        'disabled': this.out_of_stock,
                        'type': 'submit',
                        'className': 'button button--outline'
                    }, !this.out_of_stock ? _createElement('div', { 'key': '2288' }, 'Build a Package') : null, this.out_of_stock ? _createElement('div', { 'key': '2358' }, _translate(`product_out_of_stock`)) : null, _createElement('span', { 'className': 'button__loader' }, _createElement('span', {}), _createElement('span', {}), _createElement('span', {}))))), _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'section-id',
                        'value': 'template--cm_results'
                    })) : null)), _createElement('div', { 'className': 'cm_SearchResult__item-info' }, _createElement('div', { 'className': 'cm_SearchResult__item-title' }, _createElement('a', {
                        'href': this.url,
                        'className': 'cm_SearchResult__item-title-link bold'
                    }, this.removeHTML(this.title), ' ')), isWheelProduct ? _createElement('div', {
                        'className': 'cm_SearchResult__item-details',
                        'key': '3049'
                    }, this.wheel_size ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '31241'
                        }, _createElement('strong', {}, 'Size:'), ' ', this.removeHTML(this.wheel_size), '\n          ')] : null, this.wheel_offset != null ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '33311'
                        }, _createElement('strong', {}, 'Offset:'), ' ', this.wheel_offset >= 0 ? `+${ this.wheel_offset }` : this.wheel_offset, '\n          ')] : null, this.wheel_bolt_pattern ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '35941'
                        }, _createElement('strong', {}, 'Bolt Pattern:'), ' ', this.removeHTML(this.wheel_bolt_pattern.join(', ')), '\n          ')] : null, this.custom_wheel_full_finish ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '38461'
                        }, _createElement('strong', {}, 'Finish:'), ' ', this.removeHTML(this.custom_wheel_full_finish), '\n          ')] : null) : null, isTireProduct ? _createElement('div', {
                        'className': 'cm_SearchResult__item-details',
                        'key': '4094'
                    }, this.tire_size ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '41681'
                        }, _createElement('strong', {}, 'Tire Size:'), ' ', this.removeHTML(this.tire_size), '\n          ')] : null, this.custom_tire_type ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '43781'
                        }, _createElement('strong', {}, 'Tire Type:'), ' ', this.removeHTML(this.custom_tire_type), '\n          ')] : null, this.custom_tire_load_range ? [_createElement('div', {
                            'className': 'cm_SearchResult__item-detail',
                            'key': '46021'
                        }, _createElement('strong', {}, 'Load Range:'), ' ', this.removeHTML(this.custom_tire_load_range), '\n          ')] : null) : null, this.price ? _createElement('div', {
                        'className': 'cm_SearchResult__price',
                        'key': '4850'
                    }, _createElement('strong', {}, 'PRICE:'), isTireProduct || isWheelProduct ? _createElement('div', {
                        'className': 'price-container',
                        'key': '4946'
                    }, this.compare_at_price > this.price ? _createElement('div', {
                        'className': 'price compare-at-price',
                        'key': '5028'
                    }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.compare_at_price * 4)), _createElement('div', { 'className': 'set-label' }, '(', _translate(`product_set_of`, {  count: 4  }), ')')) : null, _createElement('div', { 'className': 'price' }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.price * 4)), _createElement('div', { 'className': 'set-label' }, '(', _translate(`product_set_of`, {  count: 4  }), ')'))) : null, !(isTireProduct || isWheelProduct) ? _createElement('div', {
                        'className': 'price-container',
                        'key': '5535'
                    }, this.compare_at_price > this.price ? _createElement('div', {
                        'className': 'price compare-at-price',
                        'key': '5618'
                    }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.compare_at_price))) : null, _createElement('div', { 'className': 'price' }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.price)))) : null) : null)));
                }
                return scopeIsTireProductIsWheelProduct2.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h2 cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'product-list cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []